import { FaArrowRight, FaFileAlt, FaFileCode, FaFileWord, FaPaperPlane } from "react-icons/fa";
import styles from "../mainpage/MainPage.module.css";


const AuthorInstructionsPage = () => {

    const openLink = (url) => {
        window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <div>
            <section id="author-instructions" className={styles.section}>

                <div className={styles.sectionHeading}>
                    <div className={styles.sectionIcon}>
                        <FaFileAlt />
                    </div>

                    <div>
                        <span className={styles.sectionEyebrow}>
                            Authors
                        </span>

                        <h2>
                            Author Instructions & Templates
                        </h2>
                    </div>
                </div>

                <p className={styles.sectionIntro}>
                    Authors are encouraged to prepare their
                    submissions carefully and follow the required
                    formatting guidelines for abstracts and
                    conference papers.
                </p>

                <div className={styles.templateContainer}>

                    <div className="row g-4">

                        <div className="col-lg-6">

                            <div className={styles.templateCard}>

                                <div className={styles.templateHeader}>
                                    <FaFileWord />
                                    <div>
                                        <h3>Microsoft Word</h3>
                                        <span>Conference templates</span>
                                    </div>
                                </div>

                                <div className={styles.templateItem}
                                    onClick={() => openLink("https://www.ieeeivec.org/assets/MicrosoftWord-letter.doc")}
                                >
                                    <FaFileWord />
                                    <span>US Letter Template</span>
                                    <small>DOC</small>
                                </div>

                                <div className={styles.templateItem}
                                    onClick={() => openLink("https://www.ieeeivec.org/assets/MicrosoftWord-A4.doc")}
                                >
                                    <FaFileWord />
                                    <span>A4 Template</span>
                                    <small>DOC</small>
                                </div>

                                <div className={styles.templateItem}
                                    onClick={() => openLink("https://www.ieeeivec.org/assets/IVEC_2022-Sample-Abstract.pdf")}
                                >
                                    <FaFileAlt />
                                    <span>Sample Abstract</span>
                                    <small>PDF</small>
                                </div>

                            </div>

                        </div>

                        <div className="col-lg-6">

                            <div className={styles.templateCard}>

                                <div className={styles.templateHeader}>
                                    <FaFileCode />
                                    <div>
                                        <h3>LaTeX Templates</h3>
                                        <span>Technical formatting</span>
                                    </div>
                                </div>

                                <div className={styles.templateItem}
                                    onClick={() => openLink("https://www.ieeeivec.org/assets/Template_Instructions.pdf")}
                                >
                                    <FaFileAlt />
                                    <span>Template Instructions</span>
                                    <small>PDF</small>
                                </div>

                                <div className={styles.templateItem}
                                    onClick={() => openLink("https://www.ieeeivec.org/assets/LaTeX-template_7-9-18.zip")}
                                >
                                    <FaFileCode />
                                    <span>Conference Template</span>
                                    <small>ZIP</small>
                                </div>

                                <div className={styles.templateItem}
                                    onClick={() => openLink("https://www.ieeeivec.org/assets/LaTeX_BibliographyFilesWindows_IEEEtranBST2.zip")}
                                >
                                    <FaFileCode />
                                    <span>Bibliography Files</span>
                                    <small>ZIP</small>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </section>
        </div>
    )
};

export default AuthorInstructionsPage;